// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2rdru","card":"Card_card__1Nwk8","score":"Card_score__3LYd3","video":"Card_video__1JWcD","title":"Card_title__-r43b"};